import { render, staticRenderFns } from "./ZztTixianForm.vue?vue&type=template&id=5dbfb172&"
import script from "./ZztTixianForm.vue?vue&type=script&lang=js&"
export * from "./ZztTixianForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports